module.exports = __webpack_public_path__ + "img/smart_bracelet_watch_4.c47e9fae.png";